import { useEffect, useState } from "react";
import { adminApi } from "../api.js";
import styles from "../admin.module.css";

interface DashboardData {
  eventsByCategory: Array<{ categoryId: number; slug: string; name: string; publishedCount: number }>;
  statusCounts: Array<{ status: string; n: number }>;
  warnings: Array<{ type: string; message: string }>;
}

export function Dashboard() {
  const [data, setData] = useState<DashboardData | null>(null);

  useEffect(() => {
    adminApi.get<DashboardData>("/api/admin/dashboard").then(setData);
  }, []);

  if (!data) return <p>Lädt …</p>;

  return (
    <div>
      <h1 className={styles.pageTitle}>Dashboard</h1>

      <div className={styles.card}>
        <h2>Karten nach Status</h2>
        <ul>
          {data.statusCounts.map((s) => (
            <li key={s.status}>
              {s.status === "published" ? "Veröffentlicht" : "Entwurf"}: {s.n}
            </li>
          ))}
        </ul>
      </div>

      <div className={styles.card}>
        <h2>Veröffentlichte Karten je Kategorie</h2>
        <table className={styles.table}>
          <thead>
            <tr>
              <th>Kategorie</th>
              <th>Anzahl</th>
            </tr>
          </thead>
          <tbody>
            {data.eventsByCategory.map((c) => (
              <tr key={c.categoryId}>
                <td>{c.name}</td>
                <td>{c.publishedCount}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div className={styles.card}>
        <h2>Warnungen</h2>
        {data.warnings.length === 0 ? (
          <p>Keine Warnungen.</p>
        ) : (
          <ul className={styles.warningList}>
            {data.warnings.map((w, i) => (
              <li key={i} className={styles.warningItem}>
                {w.message}
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
}
